import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#6919A3",
        d: "M39.7266 40.639H8.2954c-1.7518 0-2.8529-1.9018-2.002-3.4033L21.9088 9.5582c.8509-1.5515 3.1031-1.5515 3.954 0l15.8157 27.6775c.9009 1.5015-.2002 3.4033-1.9519 3.4033"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#8435C9",
        d: "M39.8764 34.032H8.0948l14.114-24.9247c.7508-1.3514 2.7027-1.3514 3.4534 0z"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#9C5AE2",
        d: "M32.8193 21.7198H15.1017l7.1071-12.6125c.7507-1.3514 2.7027-1.3514 3.4534 0z"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#BD89F4",
        d: "M30.1673 16.9652H17.705l4.5545-8.008c.7007-1.2511 2.5526-1.3012 3.3033 0z"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#391451",
        d: "M27.1639 27.8758c0 .5005-.1001.9509-.2503 1.4014-.1501.4004-.4004.8008-.6506 1.051-.3003.3003-.6006.5506-1.001.7007s-.8008.2503-1.2513.2503c-.4504 0-.9009-.1001-1.2512-.2503-.4004-.1501-.7508-.4004-1.001-.7007-.3003-.3003-.5005-.6506-.6506-1.051s-.2503-.9009-.2503-1.4014.1001-.9509.2503-1.4014c.1501-.4004.4003-.7507.6506-1.051.3003-.3003.6006-.5005 1.001-.6507s.8008-.2502 1.2512-.2502.9009.1001 1.2513.2502c.4004.1502.7507.4004 1.001.6507.3003.3003.5005.6506.6506 1.051.2002.4505.2503.9009.2503 1.4014m-1.5015 0c0-.3003-.0501-.5506-.1001-.8008-.1001-.2503-.2002-.4504-.3504-.6006s-.3003-.3003-.5505-.4004c-.2002-.1001-.4505-.1501-.7007-.1501-.2503 0-.4505.05-.7007.1501-.2002.1001-.4004.2503-.5505.4004-.1502.1502-.2503.4004-.3504.6006-.1001.2502-.1001.5005-.1001.8008s.05.5506.1001.8008c.1001.2503.2002.4504.3504.6506.1501.1502.3002.3003.5505.4004.2002.1001.4504.1502.7007.1502s.4504-.0501.7007-.1502c.2002-.1001.4004-.2502.5505-.4004s.2503-.4003.3504-.6506c.05-.2502.1001-.5005.1001-.8008"
    }, "4")
], "AppOrganisation", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
